import { useCreation } from 'ahooks'

import { useHasPermissionFn } from '@eastcoal/auth/hooks/useHasPermissionFn'

import { UseMenuItemsProps } from './interface'

/**
 * 处理 Menu 组件的 items 属性
 */
export const useMenuItems = ({ items }: UseMenuItemsProps) => {
  const hasPermission = useHasPermissionFn()
  return useCreation(() => {
    const authorizedItems = items
      .filter(item => {
        return (
          'type' in item || hasPermission(item.uuid, item.onlyAdministrator)
        )
      })
      .filter((item, index) => {
        const nextItem = items[index + 1]
        // 如果当前项是分割线，且下一项也是分割线，则不显示当前项
        return !('type' in item && (!nextItem || 'type' in nextItem))
      })
    const isEmpty =
      authorizedItems.filter(item => !('type' in item)).length === 0
    return {
      items: authorizedItems,
      isEmpty
    }
  }, [items, hasPermission])
}
